<template>
  <div class="nextreview-date-time-picker form-control d-flex">
    <b-dropdown
      class="flex-fill"
      no-caret
      :disabled="disabled"
      :variant="variant"
      :no-flip="true"
      :popper-opts="{
        positionFixed: true
      }"
      size="sm"
    >
      <template slot="button-content">
        <div
          class="d-flex align-items-center justify-content-between"
          style="font-size: 14px"
        >
          <div>
            <span class="mr-1 text-primary">
              Next review:
            </span>
            <span style="padding-right: 10px">{{ label }}</span>
          </div>
          <i style="font-size:23px" class="fa fa-angle-down"></i>
        </div>
      </template>
      <b-dropdown-form class="px-2">
        <b-form-group>
          <b-calendar
            v-model="date"
            :readonly="readonly"
            :width="'230px'"
            :date-disabled-fn="dateDisabledFn"
            hide-header
          />
        </b-form-group>
        <b-form-group
          class="d-flex flex-row justify-content-center align-items-center mb-0"
        >
          <div class="mt-2 text-center">
            <b-button
              :disabled="date == ''"
              size="sm"
              variant="outline-danger"
              @click="date = null"
            >
              Clear date
            </b-button>
          </div>
        </b-form-group>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import { formatDateOnly, formatDateOnlyMysql } from "../../helpers/date";

export default {
  name: "NextReviewDatePicker",
  props: {
    value: {
      type: [Date, String],
      default: null
    },
    placeholder: {
      type: String,
      default: "No date selected"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    dateDisabledFn: {
      type: Function,
      default: null
    }
  },
  methods: {
    emit(date) {
      this.$emit("input", `${date}`);
    }
  },
  computed: {
    date: {
      get() {
        return this.value ? formatDateOnlyMysql(this.value.split(" ")[0]) : "";
      },
      set(newValue) {
        this.emit(newValue);
      }
    },
    label() {
      if (this.date) {
        return formatDateOnly(this.date);
      } else {
        return this.placeholder;
      }
    },
    variant() {
      return this.errors.length ? "outline-danger" : "text";
    }
  }
};
</script>
<style scoped>
.nextreview-date-time-picker >>> .dropdown-toggle {
  padding: 0;
}
.nextreview-date-time-picker {
  height: 33px;
  padding-top: 4px;
}
</style>
